export default "__VITE_PUBLIC_ASSET__786bd919__"